module.exports = __webpack_public_path__ + "img/1f39f.1e415a5.svg";